import {NEW_HIDDEN_ALERT} from "../../../constants/PlayerConstants";
import {GeneralAction} from "../../../@types/actions";
import {HiddenObject} from "../../../@types/response";

export const NewHiddenAlertAction = (data: HiddenObject): GeneralAction<HiddenObject> => ({
    type: NEW_HIDDEN_ALERT,
    payload: data
});
